import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import { ProfileType, PropertyCountRangeType } from '@zg-rentals/ts-rental-manager-api-client';

export const normalizeUser = (): RentalManagerAuthCheckUserInfoWebApiDto => ({
  applicationsEnabled: false,
  assuranceLevel: 0,
  canAccessAnalytics: false,
  canAccessBilling: false,
  canAccessContacts: false,
  canAccessMainAnalytics: false,
  canAccessMainContacts: false,
  canAccessMultiFamilyResources: false,
  canAccessUserManagement: false,
  canAccessZramMultifamilyPropertyTable: false,
  canAddListing: false,
  canRespondToReview: false,
  canSwitchListingSource: false,
  canUpdateListing: false,
  customers: [],
  email: '',
  features: {
    canAccessAnalytics: false,
    canAccessBilling: false,
    canAccessBusinessVerificationLite: false,
    canAccessConnectedExperience: false,
    canAccessContacts: false,
    canAccessDeactivationWorkflow: false,
    canAccessFeatureLaunchNotifications: false,
    canAccessFeedClaimAndConvert: false,
    canAccessInvoicePayments: false,
    canAccessMainLeadManagement: false,
    canAccessListingCriteria: false,
    canAccessMainAccountSettings: false,
    canAccessMainAnalytics: false,
    canAccessMainBilling: false,
    canAccessMainContactSupport: false,
    canAccessMainContacts: false,
    canAccessMainHelp: false,
    canAccessMainMaintenanceTracker: false,
    canAccessMainMessages: false,
    canAccessMainMyProperties: false,
    canAccessMainNotificationCenter: false,
    canAccessMainPayments: false,
    canAccessMainResources: false,
    canAccessMainSecuritySettings: false,
    canAccessMaintenanceTracker: false,
    canAccessMessages: false,
    canAccessMobileHub: false,
    canAccessModularListing: false,
    canAccessMultiFamilyResources: false,
    canAccessNewPhotoUpload: false,
    canAccessPostActivationFeedListingEdits: false,
    canAccessPostActivationListingEdits: false,
    canAccessUserManagement: false,
    canAccessUserManagementApplicationPermission: false,
    canAddListing: false,
    canEditMultifamilyFeedListingContactInformation: false,
    canRespondToReview: false,
    canSwitchListingSource: false,
    canUpdateListing: false,
    canViewClaimFeedListing: false,
    canViewContactEmailDeliverability: false,
    canViewFeedListingDetails: false,
    canViewOnboardingFlow: false,
    canViewSingleFamilyFeedListingDetails: false,
    canDeleteListing: false,
    canClaimFreeListings: false,
  },
  firstName: '',
  hasAcceptedZillowRentalUserTerms: false,
  hasClaimedFreeListing: false,
  hasPaidForListing: false,
  hasSeenNewPaymentsPage: false,
  hasSeenRentGuarantee: false,
  hasStrongAuthentication: false,
  impersonatorEmail: '',
  impersonatorUserToken: '',
  isAcceptingApplications: false,
  isEmailVerified: false,
  isEnterpriseCustomer: false,
  isHousingConnector: false,
  isIdVerified: false,
  isImpersonationAllowed: false,
  isLeasingBeta: false,
  isMocked: false,
  isMultifamilyCustomer: false,
  isPasswordlessAccount: false,
  isPostingPathAdmin: false,
  isPremiumCustomer: false,
  isPropertyManager: false,
  isPropertyManagerCompanyAdmin: false,
  isRocketshipCustomer: false,
  isRocketshipCustomerOnly: false,
  isSelfServeCustomer: false,
  isSingleFamilyEnterpriseCustomer: false,
  isTwoFactorAuthEnabled: false,
  isTwoFactorAuthenticated: false,
  isUserBlocked: false,
  lastName: '',
  loggedIn: false,
  paymentsAccessAllowed: false,
  paymentsAcceptedCount: 0,
  profileImageUrl: '',
  profiles: {
    isLandlord: false,
    isPropertyManager: false,
    profileType: ProfileType.LANDLORD,
    propertyCountRange: PropertyCountRangeType.ONE,
  },
  roles: [],
  roleTypes: [],
  sessionSecondsRemaining: 0,
  summary: {
    activeListingCount: 0,
    isPartialResponse: false,
    totalListingCount: 0,
    archivedListingCount: 0,
  },
  userManagementCompanyId: '',
  userToken: '',
  encodedZuid: '',
  restrictions: {
    ctaText: '',
    ctaUrl: '',
    isAllowed: true,
    messageCode: '',
    partialMessages: [],
    title: '',
  },
  hasSeenPaymentsAggregatedViewModal: false,
  isInitialMultiFactorAuthenticationRequired: false,
});
